import { HttpClient } from '@adapters/HttpClient';

/**
 * Adaptador para obtener la URL de redirección a la instalación/autorización de TikTok.
 * La API devuelve la URL directamente como texto (igual que Shopify).
 */
export class TikTokRedirectApiAdapter {
  private httpClient: HttpClient;

  constructor(apiClient: HttpClient) {
    this.httpClient = apiClient;
  }

  /**
   * Obtiene la URL de redirección para la instalación de TikTok.
   * La respuesta de la API es directamente la URL como texto plano.
   * @returns {Promise<string>} La URL de redirección.
   */
  public async getRedirectUrl(): Promise<string> {
    try {
      const response = await this.httpClient.get<string>('/redirect/tiktok/install');
      return response as unknown as string;
    } catch (error: any) {
      console.error('Error fetching TikTok redirect URL:', error);
      throw new Error(
        error.response?.data?.message || error.message || 'No se pudo obtener la URL de redirección de TikTok',
      );
    }
  }
}
